// Pure validation logic kept in a separate file without UI imports.
// This allows Jest to load and test it directly — importing from Maintenance.js
// would pull in @awsui/components-react (ESM), which Jest cannot transform.
export function validateMaintenance({ message, startTimeVal, endTimeVal, showFromVal, showUntilVal }) {
  const errors = { message: "", startTime: "", endTime: "", showFrom: "", showUntil: "" };
  let valid = true;

  if (!message)      { errors.message   = "Enter a message";                     valid = false; }
  if (!startTimeVal) { errors.startTime = "Select maintenance start date/time";  valid = false; }
  if (!endTimeVal)   { errors.endTime   = "Select maintenance end date/time";    valid = false; }
  if (!showFromVal)  { errors.showFrom  = "Select announcement start date/time"; valid = false; }
  if (!showUntilVal) { errors.showUntil = "Select announcement end date/time";   valid = false; }

  if (showFromVal && startTimeVal && showFromVal > startTimeVal) {
    errors.showFrom = "Show from must be on or before Start time"; valid = false;
  }
  if (startTimeVal && endTimeVal && startTimeVal >= endTimeVal) {
    errors.endTime = "End time must be after Start time"; valid = false;
  }
  if (endTimeVal && showUntilVal && endTimeVal > showUntilVal) {
    errors.showUntil = "Show until must be on or after End time"; valid = false;
  }

  return { valid, errors };
}
